import {
  createCategoria,
  listAllCategorias,
  softDeleteCategoria,
  updateCategoria,
  type CategoriasFields,
} from '@/shared/api/controllers/categorias';
import { SimpleAbmEntity, type SimpleAbmAdapter } from '../../SimpleAbmEntity';
import type { EntityViewProps } from '../../types';

const adapter: SimpleAbmAdapter<CategoriasFields> = {
  queryKey: ['configuracion', 'categorias'],
  abmKind: 'categorias',
  listAll: listAllCategorias,
  create: createCategoria,
  update: updateCategoria,
  softDelete: softDeleteCategoria,
  valueOf: (i) => i.fields.Categoria_CAT ?? '',
  statusOf: (i) => i.fields.Status_CAT,
  fieldLabel: 'Categoría',
  fieldPlaceholder: 'Ingresar Categoría',
  entitySingular: 'categoría',
  femenino: true,
  createdMessage: 'Categoría creada correctamente.',
  updatedMessage: 'Categoría actualizada correctamente.',
  deletedMessage: 'Categoría eliminada correctamente.',
};

export function CategoriasEntity(props: EntityViewProps) {
  return <SimpleAbmEntity adapter={adapter} {...props} />;
}
